import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
function fundingProfileEndpoints(builder) {
  return {
    createFundingProfile: builder.mutation({
      query: (body) => ({
        url: `/member/funding/profile/create`,
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec(),
      invalidatesTags: ["funding-profile"]
    }),
    updateFundingProfile: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/member/funding/profile/${id}/update`,
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec(),
      invalidatesTags: ["funding-profile"]
    }),
    getFundingProfileList: builder.query({
      query: ({ query }) => ({
        url: `/member/funding/profile/list${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(),
      providesTags: ["funding-profile"]
    }),
    setFundingProfileDefault: builder.mutation({
      query: ({ id }) => ({
        url: `/member/funding/profile/${id}/default`,
        method: "POST"
      }),
      transformResponse: transformWithSpec(),
      invalidatesTags: ["funding-profile"]
    })
  };
}
export {
  fundingProfileEndpoints as default
};
